import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";
import { format } from "date-fns";

const componentRef = React.createRef();
var QRCode = require("qrcode.react");

class Autorizacion extends React.Component {
  render() {
    return (
      <Modal
        isOpen={this.props.state.previa_ada}
        modalClassName="modal-message"
      >
        <ModalHeader>
          Folio: {this.props.state.autorizacion.folio}
          <button
            type="button"
            className="close"
            onClick={this.props.change}
            style={{ position: "fixed", right: "21%" }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className={this.props.working ? "" : "hide"}>
            <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
              CARGANDO INFORMACIÓN
            </div>
          </div>

          <div className={this.props.state.working ? "hide" : ""}>
            <div
              className="row"
              ref={componentRef}
              style={{ background: "white" }}
            >
              {/*Aqui se muestra licencia******************************************************/}

              <form
                style={{
                  marginRight: "13%",
                  marginLeft: "13%",
                  color: "black",
                }}
              >
                <div style={{ textAlign: "left", margin: "3%" }}>
                  <table style={{ width: "100%", tableLayout: "auto" }}>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "left", color: "black" }}>
                          <img
                            src="../assets/Escudo.jpg"
                            width="100"
                            height="100"
                          />
                        </td>
                        <td style={{ textAlign: "right", color: "black" }}>
                          <img
                            src="../assets/1631027847767_Logo IPSA.png"
                            width="200"
                            height="100"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="75%">
                          <h5
                            style={{
                              textAlign: "center",
                              marginRight: "0%",
                              color: "black",
                            }}
                          >
                            INSTITUTO DE PROTECCIÓN Y SANIDAD AGROPECUARIA
                            DIRECCIÓN DE SALUD ANIMAL DEPARTAMENTO DE REGULACIÓN
                            Y CONTROL DE INSUMOS PECUARIOS Autorización de
                            adquisición de subproductos Nº.
                            {this.props.state.autorizacion.folio}
                          </h5>
                        </td>
                        <td width="25%">
                          <div style={{ textAlign: "right", margin: "8%" }}>
                            <QRCode
                              size="100"
                              value={
                                "Folio de autorización: " +
                                this.props.state.autorizacion.folio +
                                "\n" +
                                "ID: " +
                                this.props.state.autorizacion
                                  .subproducto_autorizacion_id
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/*QR*********************/}{" "}
                {/* <div style={{ textAlign: "right", margin: "8%" }}>
                  <QRCode
                    size="100"
                    value={
                      "Folio de autorización: " +
                      this.props.state.autorizacion.folio +
                      "\n" +
                      "ID: " +
                      this.props.state.autorizacion.subproducto_autorizacion_id
                    }
                  />
                </div>
                <h5 style={{ textAlign: "Center" }}>
                  INSTITUTO DE PROTECCIÓN Y SANIDAD AGROPECUARIA DIRECCIÓN DE
                  SALUD ANIMAL DEPARTAMENTO DE REGULACIÓN Y CONTROL DE INSUMOS
                  PECUARIOS Autorización de adquisición de subproductos Nº. 
                  {this.props.state.autorizacion.folio}
                </h5> */}
                <br></br>
                <p style={{ textAlign: "justify" }}>
                  En cumplimiento de los artículos 16, 17, 18 y 24 Resolución
                  Ejecutiva N° 099-2019, “Vigilancia de Encefalopatía
                  Espongiforme Bovina”, el suscrito especialista de salud animal
                  del establecimiento:{" "}
                  {this.props.state.autorizacion.razon_social}, Código IPSA:{" "}
                  {this.props.state.autorizacion.codigo}, dirección:{" "}
                  {this.props.state.autorizacion.direccion_establecimiento},
                  autoriza la siguiente salida de:
                </p>
                <table className="table text-black" border="1">
                  <thead>
                    <tr>
                      <th>Productos</th>
                      <th>Cantidad de sacos o cisterna</th>
                      <th>Kilogramos</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.state.autorizacion.productos != null
                      ? this.props.state.autorizacion.productos.map(
                          (pro, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{pro.nombre_comercial}</td>
                              <td>{pro.cantidad}</td>
                              <td>{pro.kilogramos}</td>
                            </tr>
                          )
                        )
                      : null}
                  </tbody>
                </table>
                <br></br>
                <p style={{ textAlign: "justify" }}>
                  Con destino a la planta:{" "}
                  {this.props.state.autorizacion.destino} autorizada por la
                  Dirección de Salud Animal.
                </p>
                <p style={{ textAlign: "justify" }}>
                  Nombre y apellido del conductor:{" "}
                  {this.props.state.autorizacion.nombre_conductor}{" "}
                  {this.props.state.autorizacion.apellido_conductor}
                </p>
                <p style={{ textAlign: "justify" }}>
                  Número de cédula:{" "}
                  {this.props.state.autorizacion.numero_cedula}
                </p>
                <p style={{ textAlign: "justify" }}>
                  Tipo de vehículo:{" "}
                  {this.props.state.autorizacion.tipo_vehiculo}
                </p>
                <p style={{ textAlign: "justify" }}>
                  Número de placa: {this.props.state.autorizacion.numero_placa}
                </p>
                <p style={{ textAlign: "justify" }}>
                  Número de marchamo:{" "}
                  {this.props.state.marchamo === ""
                    ? "N/A"
                    : this.props.state.marchamo}
                </p>
                <p style={{ textAlign: "justify" }}>
                  La harina elaborada procede de animales que han sido objeto de
                  inspección oficial ante-mortem y post-mortem, los cuales al
                  momento del sacrificio no presentaban ninguna enfermedad
                  infecto-contagiosa, cumpliendo con lo establecido en el
                  Artículo 11.5.19 del Código Sanitario para los Animales
                  Terrestres de la OIE.
                </p>
                <p style={{ textAlign: "justify" }}>
                  La harina de carne y hueso no debe ser utilizada para la
                  elaboración de alimentos para bovinos y otros rumiantes.
                  Además, debe ser manejado de forma adecuada para prevenir la
                  contaminación cruzada.
                </p>
                <p style={{ textAlign: "justify" }}>
                  Queda prohibido vender, ceder, prestar y/o donar los
                  subproductos adquiridos a plantas no autorizadas.
                </p>
                <p style={{ textAlign: "justify" }}>
                  Se extiende la presente autorización de salida en la ciudad de{" "}
                  {this.props.state.autorizacion.ciudad}, departamento de{" "}
                  {this.props.state.autorizacion.departamento}, Nicaragua, a{" "}
                  {this.props.state.autorizacion.fecha_emision != null
                    ? format(
                        new Date(this.props.state.autorizacion.fecha_emision),
                        "dd/MM/yyyy"
                      )
                    : this.props.state.autorizacion.fecha_emision}
                  .
                </p>
                {/* this.props.state.autorizacion.firma !== null? 
                  <img
                    style={{ textAlign: "center", margin: "8%" }}
                    src={this.props.state.autorizacion.firma}
                  />
                  : null*/}
                <p
                  style={{
                    textAlign: "center",
                    margin: "8%",
                    marginTop: "15em",
                  }}
                >
                  <center>
                    <div
                      style={{ borderBottom: "1px solid #333", width: "50%" }}
                    ></div>
                  </center>
                  Firma y sello <br></br>
                  Dr. {this.props.state.autorizacion.usuario} <br></br>
                  Especialista en Salud Animal Asignado al Establecimiento
                  <br></br>
                </p>
              </form>
            </div>
            <hr />
          </div>
        </ModalBody>
        <ModalFooter>
          <ReactToPrint
            content={() => componentRef.current}
            pageStyle=""
            trigger={() => (
              <button id="btn-imprimir" className="btn btn-primary m-r-5">
                Imprimir
              </button>
            )}
          />
          <button className="btn btn-danger" onClick={this.props.change}>
            Regresar
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default Autorizacion;
